import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from '../SnackBar';

export const RULE_CATEGORY_GROUP_REQUEST = 'RULE_CATEGORY_GROUP_REQUEST';
export const RULE_CATEGORY_GROUP_FAILURE = 'RULE_CATEGORY_GROUP_FAILURE';
export const RULE_CATEGORY_GROUP_SUCCESS = 'RULE_CATEGORY_GROUP_SUCCESS';

/**
 * ONE REQUEST, not one per category.
 *
 * The sets this is for are 297 categories long. Patching them one at a time
 * would be 297 round trips, 297 audit flushes and 297 cache invalidations, and
 * a half-applied result the moment one of them failed. The endpoint takes the
 * whole list and either applies it or refuses it.
 *
 * The store is updated from the ids that were SENT rather than from the
 * response, which reports only how many rows actually changed — categories
 * already in the target group are not rewritten, and the client's picture of
 * them is correct either way.
 */
export const assignRuleCategoryGroup = (rule, categories, group) => {
    return function(dispatch) {
        const params = [];
        params['id'] = rule;
        dispatch(assignRequest());
        return axios(apiRequestOptions(apiPath.RULES.CATEGORY_GROUP, { group, categories }, { params }))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(assignSuccess(rule, categories, group));
                dispatch(addSuccessMessage(
                    `Group ${group} assigned to ${response.data.updated} categories`
                ));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(assignFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const assignRequest = () => ({ type: RULE_CATEGORY_GROUP_REQUEST });

const assignFailure = (error) => ({ type: RULE_CATEGORY_GROUP_FAILURE, error });

const assignSuccess = (rule, categories, group) => ({
    type: RULE_CATEGORY_GROUP_SUCCESS, rule, categories, group,
});
